// extracted by mini-css-extract-plugin
module.exports = {"component":"admin_user_auth_component__9qRKt","auth-button-wrapper":"admin_user_auth_auth-button-wrapper__9htfz"};